export enum OrderTypeEnum {
  buy = "buy",
  sell = "sell",
}
